import { useEffect } from "react";

import LoginCard from "components/LoginCard";
import SignupCard from "components/SignupCard";
import Billboard from "components/General/Billboard";
import GuestServicesCard from "components/GuestServicesCard";

import { useBreadcrumb } from "hooks/useBreadcrumb";

import { useDispatch } from "react-redux";
import { removeUser } from "redux/slices/userSlice";
import { removeCsrUser } from "redux/slices/csrUserSlice";
import { removePolicies } from "redux/slices/searchPoliciesSlice";
import { Trans, useTranslation } from "react-i18next";
import { getImage } from "js/utilities";

export default function LandingEVL({
  portal,
  setHideCustomChat,
  connectingToSF,
  setConnectingToSF,
  openChatWindow,
  setOpenChatWindow,
  bannerMessage,
  bannerTitle,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(removeUser());
    dispatch(removeCsrUser());
    dispatch(removePolicies());
    const esb = window?.embeddedservice_bootstrap;
    if (!esb?.userVerificationAPI || !esb?.utilAPI) {
      // embeddedservice_bootstrap not loaded or not available in this context
      return;
    }
    try {
      esb.userVerificationAPI
        .clearSession(true)
        .then(() => {
          esb.utilAPI.removeAllComponents();
        })
        .catch(() => {
          console.log("Error Clearing SFDC Componenets");
        });
    } catch {
      console.log("Error Clearing SFDC Componenets");
    }
  }, []);

  useBreadcrumb([]);
  return (
    <>
      <div className="container mb-8">
        <h1>{t("UnAuthLandingPage-customerTitle")}</h1>
        <hr />
      </div>
      {bannerMessage && (
        <div className="container ui-component-spacing">
          <Billboard
            data={{
              title: <>{bannerTitle ?? t("Notice-title")}</>,
              svgClass: "text-ui-green",
              svgUse: "ui-icon-border-good",
              description: (
                <Trans
                  i18nKey={bannerMessage}
                  components={{
                    phoneLifeTerm: <a href="tel:+18449530347" />,
                    phoneAnnuity: <a href="tel:+18449532815" />,
                  }}
                />
              ),
            }}
          />
        </div>
      )}

      <div className="container ui-component-spacing">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 xl:gap-6">
          <LoginCard loginType={portal} setHideCustomChat={setHideCustomChat} />
          <SignupCard />
          <GuestServicesCard
            setHideCustomChat={setHideCustomChat}
            connectingToSF={connectingToSF}
            setConnectingToSF={setConnectingToSF}
            openChatWindow={openChatWindow}
            setOpenChatWindow={setOpenChatWindow}
          />
        </div>
      </div>

      <div className="container ui-component-spacing">
        <div
          style={{ "--image-url": `url(${getImage("image1.jpg")})` }}
          className={`ui-card relative overflow-hidden mb-10 lg:mb-12 sm:bg-contain sm:bg-right sm:bg-origin-border sm:bg-no-repeat sm:bg-[image:var(--image-url)]`}
        >
          <img
            src={getImage("image1.jpg")}
            className="w-full h-auto sm:hidden"
            alt="lifestyle photo of family"
          />
          <div className="w-full sm:w-1/2 md:w-3/5 lg:w-1/2">
            <div
              className="p-4 md:p-8 lg:p-10 xl:p-20"
              style={{
                // background: "rgb(255,255,255)",
                background:
                  "linear - gradient(90deg, rgba(255, 255, 255, 1) 0 %, rgba(255, 255, 255, 1) 75 %, rgba(255, 255, 255, .85) 85 %, rgba(255, 255, 255, 0) 99 %)",
              }}
            >
              <div className="pr-14">
                <h2 className="text-2xl mb-2 md:text-3xl lg:text-5xl md:mb-6 lg:mb-8">
                  {t("Banner-title")}
                </h2>
                <p className="mb-4 md:mb-6 lg:mb-8">
                  {t("Banner-description")}
                </p>
                {/* <Link to="/" className="ui-btn-primary">
                  Call to Action
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
